import { ContestTypes } from '@maxpreps/apiserviceclients/apiModels';

interface IContestTypeConfig {
  label: string;
  value: ContestTypes;
}

export const CONTEST_TYPE_CONFIG = new Map<ContestTypes, IContestTypeConfig>([
  [
    ContestTypes.Conference,
    {
      label: 'Conference',
      value: ContestTypes.Conference
    }
  ],
  [
    ContestTypes.NonConference,
    {
      label: 'Non-Conference',
      value: ContestTypes.NonConference
    }
  ],
  [
    ContestTypes.Tournament,
    {
      label: 'Tournament',
      value: ContestTypes.Tournament
    }
  ],
  /*[
    ContestTypes.Exhibition,
    {
      label: 'Exhibition', value: ContestTypes.Exhibition
    }
  ],*/
  [
    ContestTypes.Playoff,
    {
      label: 'Playoff',
      value: ContestTypes.Playoff
    }
  ],
  [
    ContestTypes.ConferenceTournament,
    {
      label: 'Conference Tournament',
      value: ContestTypes.ConferenceTournament
    }
  ]
]);

export const CONTEST_TYPE_FORM_OPTIONS = Array.from(CONTEST_TYPE_CONFIG).map(
  ([k, v]) => v
);
